import React from "react";
import awards from "../../data/awards";
const Awards = () => {
  return (
    <>
      <div className="bg-blue-800 p-20 lg:mb-[100px]">
        <h1 className="text-[35px] lg:text-[50px]  text-white font-bold text-center block mx-auto">
          Awards and International Association
        </h1>
      </div>
      <div className="container mx-auto">
        <div className=" mt-[25px] lg:mt-[50px]">
          <div className="grid lg:grid-cols-3 gap-[30px] mt-[30px]">
            {awards?.map((a) => (
              <div>
                <img
                  src={a.img}
                  alt="Mind Works Programme"
                  className=" rounded-lg block mx-auto lg:h-[300px] lg:w-[520px] object-cover"
                />
                <p className=" text-blue-800 font-bold text-xl text-center flex justify-center mt-[20px]">
                  {a.title}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Awards;
